import React from 'react';
import ShellContainer from './shell/shellContainer';
import LoginContainer from './login/loginContainer';
import ResetPasswordContainer from './resetPassword/resetPasswordContainer';

/**
 * Main frame component. Loads 'Login', 'ResetPassword' or 'Shell' depending on auth and route.
 */
class ContainerFrame extends React.Component {

	componentDidMount() {
		var token = localStorage.getItem('token');
		if (token !== undefined) {
			//this.props.autoLogin(token);
		}

		// Load city2zip.json data on app startup
		if (!this.props.isCityZipDataLoaded) {
			this.props.loadCityZipData();
		}
	}

	render() {
		if (this.props.isAuthenticated) {
			return <ShellContainer />;
		}
		if (this.props.location.pathname === '/reset-password') {
			return <ResetPasswordContainer />;
		}
		return <LoginContainer />;
	}
}

export default ContainerFrame;